import angular from 'angular';
import './docrepo-invoice-list.component.js';

(function() {
    'use strict';

    angular.module('app.docrepo_invoice').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.docrepoinvoice', {
                abstract: true,
                component: 'contentLayout'
            })
            .state('app.docrepoinvoice.list', {
                url: '/docrepo-invoice/list',
                views: {
                    content: {
                        component: 'docrepoInvoiceList'
                    }
                },
                data: {
                    authorizedRole: 'ADMIN'
                }
            })
            .state('app.docrepoinvoice.detail_tabs', {
                url: '/docrepo-invoice/detail/{guid}',
                views: {
                    content: {
                        component: 'docrepoInvoiceTabs'
                    }
                },
                params: {
                    guid: null,
                    invoice: null
                },
                resolve: {
                    invoice: [
                        '$transition$',
                        function($transition$) {
                            return $transition$.params().invoice;
                        }
                    ],
                    guid: [
                        '$transition$',
                        function($transition$) {
                            return $transition$.params().guid;
                        }
                    ]
                },
                data: {
                    authorizedRole: 'ADMIN'
                }
            });
    }
})();
